// indicatorHelpers.js
import React from 'react';
import { SquareFoot, Toll, StackedLineChart, Inventory, Insights, QuestionMark, Autorenew, BackHand } from '@mui/icons-material';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { getIconWithTooltip } from '../../b2b-plans/components/helper';
import useB2BTranslation from '../../b2b-common/hooks/useB2BTranslation';

export const IndicatorIcon = ({ indicator }) => {
    const { t } = useB2BTranslation('b2b-indicators');
    switch (indicator.indicatorDTOType) {
        case 'QUANTITATIVE':
            return getIconWithTooltip(SquareFoot, {}, t('Quantitative'));
        case 'QUALITATIVE':
            return getIconWithTooltip(Toll, {}, t('Qualitative'));
        case 'QUANTITATIVE_DIMENSIONAL':
            return getIconWithTooltip(StackedLineChart, {}, t('Quantitative Dimensional'));
        default:
            return null;
    }
}

export const IndicatorScope = ({ indicator }) => {
    const { t } = useB2BTranslation('b2b-indicators');
    switch (indicator.indicatorScope) {
        case 'ORGANIZATION':
            return getIconWithTooltip(Insights, {}, t('Organization custom indicator'));
        case 'PRODUCT':
            return getIconWithTooltip(Inventory, {}, t('Back2Blu indicator'));
        default:
            return <QuestionMark />;
    }
}

export const IndicatorAutomatic = ({ indicator }) => {
    const { t } = useB2BTranslation('b2b-indicators');
    switch (indicator.automaticSampling) {
        case true:
            return getIconWithTooltip(Autorenew, {}, t('Automatic sampling'));
        case false:
            return getIconWithTooltip(BackHand, {}, t('Manual sampling'));
        default:
            return getIconWithTooltip(BackHand, {}, t('Manual sampling'));
    }
}

export const IndicatorType = ({ indicator }) => {
    const { t } = useB2BTranslation('b2b-indicators');
    if (indicator.indicatorDTOType === 'QUANTITATIVE') {
        return (t('Quantitative'))
    } else if (indicator.indicatorDTOType === 'QUALITATIVE') {
        return (t('Qualitative'))
    } else if (indicator.indicatorDTOType === 'QUANTITATIVE_DIMENSIONAL') {
        return (t('Quantitative Dimensional'))
    } else {
        return (t('Unknown Indicator Type'))
    }
}

export const IndicatorMetricsAnType = ({ indicator }) => {
    const { t } = useB2BTranslation('b2b-indicators');
    if (indicator.indicatorDTOType === 'QUANTITATIVE') {
        return indicator.quantitativeMeasurementUnitDTO.quantitativeMeasurementUnitName;
    } else if (indicator.indicatorDTOType === 'QUALITATIVE') {
        return indicator.qualitativeTypeDTO.qualitativeTypeName;
    } else if (indicator.indicatorDTOType === 'QUANTITATIVE_DIMENSIONAL') {
        return `${indicator.dimensionalType.dimensionTypeName}, ${indicator.quantitativeMeasurementUnitDTO.quantitativeMeasurementUnitName}`;
    } else {
        return (t('Unknown Indicator Type'))
    }
}

export const IndicatorSystemFieldsTable = ({ indicator }) => {
    const { t } = useB2BTranslation('b2b-indicators');
    return (
        <Table size="small" aria-label="a dense table">
            <TableHead>
                <TableRow>
                    <TableCell align="center">{t('Indicator ID')}</TableCell>
                    <TableCell align="center">{t('Indicator UUID')}</TableCell>
                    <TableCell align="center">{t('Indicator Type')}</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                <TableRow>
                    <TableCell align="center">{indicator.indicatorId}</TableCell>
                    <TableCell align="center">{indicator.indicatorUUID}</TableCell>
                    <TableCell align="center">{indicator.indicatorDTOType}</TableCell>
                </TableRow>
            </TableBody>
        </Table>
    );
}

